import btecBnbCakeLpFarmingPool from "../abis/production/btecBnb/pools/btecFarming";

const host = "https://bscscan.com/address";
const swapHost = "https://pancakeswap.finance/add";
const pairHost = "https://pancakeswap.info/pool";

export default [
  {
    title: "BTEC-BNB Cake LP Farming",
    type: "bnb",
    contractAddress: "0x8FE46917fbAD6093633161b30b7be87b0F72D1d1",
    minApr: 159,
    abi: btecBnbCakeLpFarmingPool.abi,
    url: `${host}/0x8FE46917fbAD6093633161b30b7be87b0F72D1d1`,
    swapUrl: `${swapHost}/BNB/0xAf307c4Ea25c8d2A7029Dc0322396A6b4B00A0Fc`,
    pairUrl: `${pairHost}/0x97fbF0dCc48d4E82D408D7d5f287c206125DA5D8`,
  },
];
